import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import {Button, Text} from '@tenancy.nz/ui';
import {motion} from 'framer-motion';
import PartnerLogo from './partner-logo';

function PartnerNavList({collapsed = false}) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'));
  const styles = {
    button: {
      transition: 'width 0.28s linear',
      '&&': {
        bgcolor: '#ffffff',
        borderColor: 'grey.300',
      },
      ...(collapsed && {
        '&&': {
          height: '48px !important',
          padding: '0 !important',
          width: '48px',
          minWidth: '0px',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }),
    },
  };
  return (
    <Stack
      sx={{
        gap: 4,
        alignItems: collapsed ? 'center' : 'stretch',
      }}>
      <motion.div
        initial={false}
        animate={{
          opacity: collapsed ? 0 : 1,
          height: collapsed ? 0 : 'auto',
        }}
        transition={{duration: 0.28, ease: [0.77, 0.2, 0.05, 1]}}
        style={{overflow: 'hidden'}}>
        {!collapsed && (
          <Text weight="600" noWrap>
            Integrated with
          </Text>
        )}
      </motion.div>
      <Button
        as="a"
        href="https://www.allhouse.co.nz"
        rel="noopener noreferrer"
        variant="outlined"
        size={isMobile ? 'large' : 'medium'}
        target="_blank"
        sx={styles.button}>
        {collapsed ? (
          <PartnerLogo name="allhouse_icon" width="24px" height="24px" />
        ) : (
          <PartnerLogo name="allhouse" width="102px" height="auto" />
        )}
      </Button>
      <Button
        as="a"
        href="https://www.oneroof.co.nz"
        rel="noopener noreferrer"
        variant="outlined"
        size={isMobile ? 'large' : 'medium'}
        target="_blank"
        sx={styles.button}>
        {collapsed ? (
          <PartnerLogo name="oneroof_icon" width="24px" height="24px" />
        ) : (
          <PartnerLogo name="oneroof" width="112px" height="auto" />
        )}
      </Button>
      <Button
        as="a"
        href="https://www.realestate.co.nz"
        rel="noopener noreferrer"
        variant="outlined"
        size={isMobile ? 'large' : 'medium'}
        target="_blank"
        sx={styles.button}>
        {collapsed ? (
          <PartnerLogo name="realestate_icon" width="24px" height="24px" />
        ) : (
          <PartnerLogo name="realestate" width="158px" height="auto" />
        )}
      </Button>
    </Stack>
  );
}

PartnerNavList.propTypes = {
  collapsed: PropTypes.bool,
};

PartnerNavList.defaultProps = {
  collapsed: false,
};

export default PartnerNavList;
